import React from 'react';
import { Tab } from 'react-bootstrap';
import PropTypes from 'prop-types';

import LinksList from '../LinksList';

const List = ({ guides, onSelectKey }) => (
  <>
    {guides.map((item) => (
      <Tab.Pane eventKey={item.category_name} key={item.id}>
        <div className="guides__list-header">
          <div className="title">{item.category_name}</div>
          <div className="content">{item.category_description}</div>
        </div>

        <div className="guides__list-body">
          <LinksList
            type="categories"
            items={item?.articles}
            fieldName="title"
            onClick={(tabData) => onSelectKey(`${item.category_name}.${tabData.title}`)}
          />
        </div>
      </Tab.Pane>
    ))}
  </>
);

List.propTypes = {
  guides: PropTypes.array,
  onSelectKey: PropTypes.func,
};

export default List;
